import events from './events'
import store from 'reducers'
import Actions from './Actions'
import dayjs from 'lib/helpers/dayjs';
import FilterActions from './FilterActions'
import TimeSlotActions from './TimeSlotActions'
import SelectedTimeSlotActions from './SelectedTimeSlotActions';

export default class AvailabilityActions extends Actions{
    static get target(){
        return 'availabilities'
    }

    static fetch (data) {
        let refreshSyncData = {
            organizationID: data.organizationID,
            date: dayjs(data.startingAt).format('YYYY-MM-DD'),
            numberOfDays: dayjs(data.endingAt).diff(dayjs(data.startingAt), 'days') + 1
        }
        
        return this.client.organizations.refreshSync(refreshSyncData).then(()=>(
            this.client.organizations.availabilities.fetch(data)
        ))
    }

    static clear(){
        FilterActions.set({
            ...store.getState().filters,
            availabilitiesReceived: []
        })
        TimeSlotActions.set([])
        this.set({})
    }
}


// WEBPACK FOOTER //
// ./actions/AvailabilityActions.js